/** Lit token + rôle depuis localStorage (après connexion). */
export function getAuthState() {
  const token = localStorage.getItem('token')
  if (!token) {
    return { isAuthenticated: false, role: null }
  }
  try {
    const raw = localStorage.getItem('user')
    if (!raw) return { isAuthenticated: true, role: null }
    const user = JSON.parse(raw)
    const role = user?.role ? String(user.role).toLowerCase().trim() : null
    return { isAuthenticated: true, role }
  } catch {
    return { isAuthenticated: true, role: null }
  }
}

/** Vérifie si le rôle peut accéder à cette route. */
export function canAccessRoute(path, role) {
  if (path.startsWith('/admin')) {
    return role === 'admin'
  }
  if (path.startsWith('/uploader')) {
    return role === 'admin' || role === 'uploader'
  }
  return true
}

/** Où rediriger un utilisateur connecté qui n'a pas le bon rôle. */
export function defaultHomeForRole(role) {
  if (role === 'admin') return '/admin/dashboard'
  if (role === 'uploader') return '/uploader/dashboard'
  return '/dashboard'
}

/** Après login : destination si ?redirect= est valide pour ce rôle. */
export function resolvePostLoginRedirect(redirectPath, role) {
  if (!redirectPath || typeof redirectPath !== 'string') return null
  if (!redirectPath.startsWith('/') || redirectPath.startsWith('//')) return null
  if (!canAccessRoute(redirectPath, role)) return null
  return redirectPath
}
